<template>
  <!-- 确认提示框-组件 -->
  <div style="position: absolute; top: 0; right: 0; left: 0; bottom: 0; background-color: rgba(0, 0, 0, 0.2);" v-if="visible" @click.stop.self>
      <div style="position: absolute; margin: auto; top: 0; right: 0; bottom: 0; left: 0;  padding-bottom:54px; width: 320px; border-radius: 2px; background-color: #ffffff; box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);"
          :style="{'padding-top':config.title? '30px' :0, height:config.title? '170px' :'140px'}">
          <p style="position: absolute; top:10px; left:0; width:100%; padding: 0px 16px; font-size: 16px; line-height: 20px; width: 100%;" v-show="config.title">{{config.title}}</p>
          <div style="height:100%; padding: 15px 16px 10px 16px; overflow:auto;">
              <p >{{config.message}}</p>
          </div>
          <div style="position: absolute; bottom:0; left0; width:100%; padding-top:12px; height:54px; border-top: 1px solid #eaeaea; text-align:right;">
              <button type="button" class="button" style="margin-right:10px;" @click="cancel" v-if="config.type==='confirm'">{{config.cancel_text}}</button>
              <button type="button" class="button button-blue" style="margin-right:14px;" @click="done">{{config.done_text}}</button>
          </div>
      </div>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      def_config: {
        title: '',
        // alert || confirm
        type: 'alert',
        message: '',
        cancel_text: '取消',
        done_text: '确定',
        done: function () { },
        cancel: function () { },
      },
      config: {
        title: null,
        type: null,
        message: null,
        cancel_text: null,
        done_text: null,
        done: null,
        cancel: null
      },
      visible: false
    }
  },
  methods: {
    open: function (config) {
      if (this.visible || !config) return;
      Object.assign(this.config, this.def_config, config);
      this.visible = true;
    },
    cancel: function () {
      if (this.config.cancel) this.config.cancel();
      this.close();
    },
    done: function () {
      if (this.config.done) this.config.done();
      this.close();
    },
    close: function () {
      this.visible = false;
      Object.assign(this.config, this.def_config);
    }
  }
}
</script>
